import React from 'react';
import { StyleSheet } from 'react-native';

import { LoadingSkeleton } from '@/components/SkeletonLoader';
import { Box } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';
import { designSystem } from '@/styles/styles';

export const LobbyLeagueSkeleton = () => {
    return (
        <Box alignItems="center" justifyContent={'center'} paddingLeft="s16" paddingTop={'s14'}>
            <Box backgroundColor={ds.colorToken.background.neutral.subtler} style={styles.logo} width={44} height={44}>
                <LoadingSkeleton
                    skeletonColor={designSystem.colors.neutral300}
                    width={44}
                    height={44}
                    style={styles.logo}
                />
            </Box>
            <LoadingSkeleton
                skeletonColor={designSystem.colors.neutral300}
                width={45}
                height={16}
                borderRadius="r4"
                marginTop="s8"
            />
        </Box>
    );
};

const styles = StyleSheet.create({
    logo: {
        borderRadius: 13,
    },
});
